import React, { FC, Ref } from 'react'

import Icon, { ICON_TYPES } from '../Icon/Icon'

import './SearchInput.scss'

export enum SEARCH_INPUT_SIZES {
  DEFAULT = 'M',
  M = 'M',
  XL = 'XL',
}

type SearchInputProps = {
  onClearQuery?: () => void,
  onSearch: (searchValue: string) => void,
  placeholder?: string,
  query?: string,
  searchInputRef?: Ref<HTMLInputElement>,
  size?: SEARCH_INPUT_SIZES,
}

const SearchInput: FC<SearchInputProps> = ({
  onClearQuery,
  onSearch,
  placeholder = 'Search',
  query,
  searchInputRef,
  size = SEARCH_INPUT_SIZES.DEFAULT,
}) => (
  <div className={`SearchInput size-${size}`}>
    <Icon
      size={size === SEARCH_INPUT_SIZES.XL ? "27px" : "24px"}
      type={ICON_TYPES["search"]}
    />
    <input
      className={size === SEARCH_INPUT_SIZES.XL ? "type--text-L" : "type--text-S"}
      onChange={e => onSearch(e.target.value)}
      placeholder={placeholder}
      ref={searchInputRef}
      type="text"
      value={query}
    />
    {query && query.length > 0 && (
      <button
        className="clear-button"
        onClick={e => {
          e.preventDefault()
          if (onClearQuery) onClearQuery()
        }}
      >
        <Icon
          size={size === SEARCH_INPUT_SIZES.XL ? "30px" : "24px"}
          type={ICON_TYPES["close-circle"]}
        />
      </button>
    )}
  </div>
)

export default SearchInput
